<template>
    <div>
        <transition name="fade" mode="out-in">
            <div class="position-absolute top-50 start-50 translate-middle w-75 d-flex justify-content-center text-center" v-if="step == 'choose_role'">
                <div class="d-flex flex-column me-5">
                    <img src="imgs/teacher.png" width="100" />
                    <button type="submit" class="btn-login mt-2" @click="openForm('teacher')">我是老師</button>
                </div>
                <div class="d-flex flex-column ms-5">
                    <img src="imgs/student.png" width="100" />
                    <button type="submit" class="btn-login mt-2" @click="openForm('student')">我是學生</button>
                </div>
            </div>
        </transition>
        <transition name="fade" mode="out-in">
            <div class="position-absolute top-50 start-50 translate-middle w-75 d-flex justify-content-center text-center" v-if="step == 'form'">
                <form class="col-lg-7"  @submit.prevent @submit="save_data()">
                    <div class="mb-3 d-flex">
                        <input type="text" class="form-control" id="name" placeholder="Name" v-model="registration_data.name">
                        <select class="ms-2 form-control" id="gender" placeholder="Gender" v-model="registration_data.gender" >
                            <option selected :value="null">Select Gender</option>
                            <option v-for="i in gender_list" :key="i" :value="i">{{i}}</option>
                        </select>
                    </div>
                    <div class="mb-3">
                        <input type="email" class="form-control" id="email" placeholder="Email" v-model="registration_data.email">
                    </div>
                    <div class="mb-3">
                        <el-date-picker class="w-100" type="date" placeholder="Birth Day" :prefix-icon="null" v-model="registration_data.birthday">
                        </el-date-picker>
                    </div>
                    <div class="mb-3">
                        <input type="text" class="form-control" id="school" placeholder="Your School" v-model="registration_data.school">
                    </div>
                    <div class="mb-3 d-flex">
                        <input type="text" class="form-control" id="class" placeholder="class" v-model="registration_data.class">
                        <input type="number" class="ms-2 form-control" id="number" placeholder="number" v-model="registration_data.classID">
                    </div>
                    <div class="mb-3">
                        <input type="password" class="form-control" id="password" placeholder="Password" v-model="registration_data.password">
                    </div>
                    <!-- <div class="mb-3 form-check">
                        <input type="checkbox" class="form-check-input" id="exampleCheck1">
                        <label class="form-check-label" for="exampleCheck1">Check me out</label>
                    </div> -->
                    <button type="submit" class="btn-login w-100">Create Account</button>
                </form>
            </div>
        </transition>
    </div>
</template>

<script>
export default {
    name: 'Registration',
    data(){
        return {
            step: "choose_role",
            role: null,
            gender_list: ["Male", "Female", "Intersex", "Non-binary", "Genderqueer", "Bigender", "Transgender"
            , "Agender", "I prefer not to say"],
            registration_data: {
                name: null,
                gender: null,
                birthday: null,
                school: null,
                class: null,
                classID: null,
                password: null,
                email: null
            }
        }
    },
    methods:{
        openForm(role){
            this.step = 'form'
            this.role = role
            this.registration_data.role = role
        },
        save_data(){
            let that = this
            console.log(this.registration_data)
            let error_str = ""
            for(var key in this.registration_data){
                if(this.registration_data[key] == null || this.registration_data[key] == "" || this.registration_data[key] == undefined){
                    error_str += `${key}, `
                }
            }
            if(error_str.length > 0){
                alert(`${error_str}is empty.`)
                return false
            }

            this.axios.post('/registration', this.registration_data).then(data=>{
                console.log(data.data)
                if(data.data.status == false){
                    if(data.data.data.type == "existed_error"){
                        alert("該Email已被使用")
                    }else{
                        alert("請稍後重試")
                    }
                    return false
                }
                else if (data.data.status == true){
                    alert("註冊成功，請用您的使用者名稱與密碼登入")
                    that.$router.push("/login")
                }
            })
        }
    },
}
</script>
<style>
.btn-login {
    background: #FFFFFF;
    border: 2px solid #565A97;
    box-sizing: border-box;
    box-shadow: 0px 4px 4px rgba(0, 0, 0, 0.25);
    border-radius: 30px;
}
</style>
<style lang="scss">
.form-control{
    border-radius: unset !important;
    border: unset !important;
    border-bottom: 2px solid #7A7A7A !important;
    box-shadow: 0 4px 2px -2px rgba(0, 0, 0, 0.25);
    color: #7A7A7A !important;
}
.el-input__inner{
    @extend .form-control;
}
.el-input__inner .el-input__prefix{
    display: none !important;
}
</style>
